import Framework from 'framework';
import { proxyToProspectProfileStore } from './proxyToEnterpriseFramework';

// This file can be removed when this is done: https://ltt.atlassian.net/browse/ESR-7543
const ProspectProfileStore = {
	name: 'ProspectProfileStore',
	getInitialData: proxyToProspectProfileStore('getInitialData'),
	listen: proxyToProspectProfileStore('listen'),
	updateProspectClub: proxyToProspectProfileStore('updateProspectClub') // still used by schedules-components
};

Framework.registerStore(ProspectProfileStore.name, ProspectProfileStore);

export default ProspectProfileStore;
